import { useState, useEffect } from "react";
import PageHero from "../../Component/PageHero/PageHero";
import { Image, Result } from "antd";
import AddAddress from "../../Component/AddAddress/AddAddress";
import styles from "../../styles/pages/my-addresses.module.scss";
import { Button, Modal, Radio, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setCustomerAddresses } from "../../redux/user/user.action";
import Api from "../../Network/ApiConfig";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import img_1 from "../../images/Icon material-delete.png";
import { useLocation } from "react-router-dom";
import  en  from "../../localization/en"; // Assuming you have a localization file
import { css } from "@emotion/css";
function MyAddresses() {
  const t = en;
  const [currentPage, setCurrentPage] = useState("");
  // const [loginLoading, setloginLoading] = useState(false);
  const [addressSelect, setaddressSelect] = useState(null);
  const { userAddress, currentLang, currentUser } = useSelector(
    (state) => state.user || {}
  );
  
  const location = useLocation();
  const { confirm } = Modal;
  console.log(location);
  useEffect(() => {
    if (location?.state?.show_add_address) {
      setCurrentPage("ADD_ADDRESS");
    }
  }, []);

  // const onSelectAddress = () => {
  //   if(!addressSelect){
  //     return false;
  //   }
  //   setloginLoading(true);
  //   Api.get(`Customers/SetCustomerAddressDefault?CustomerAddressId=${addressSelect}`).then(
  //     (res) => {
  //       setloginLoading(false);
  //       if(res?.status === 200){
  //         message.success(res?.data?.metas?.message);
  //         setaddressSelect(addressSelect);
  //       }
  //     },
  //     (err) => {
  //       setloginLoading(false);
  //       message.error(err?.message);
  //     }
  //   );
  // };

  const handelDltAddress = (Id) => {
    console.log("radio checked", Id);
    confirm({
      title: t.doYouWantToDeleteThisAddress,
      icon: <ExclamationCircleOutlined />,
      okText: t.ok,
      cancelText: t.cancel,
      onOk: () => {
        Api.delete(
          `Customers/DeleteCustomerAddress?CustomerAddressId=${Id}`
        ).then(
          (res) => {
            if (res?.status === 200) {
              message.success(res?.data?.metas?.message);
              const filterAddress = userAddress?.filter(
                (address) => address?.Id !== Id
              );
              dispatch(setCustomerAddresses(filterAddress));
            }
          },
          (err) => {
            // setloginLoading(false);
            message.error(err?.message);
          }
        );
      },
      onCancel: () => {},
    });
  };

  const dispatch = useDispatch();
  // useEffect(() => {
  //   Api.get("Customers/GetCustomerAddresses").then(
  //     (res) => {
  //       dispatch(setCustomerAddresses(res?.data?.model));
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }, []);

  useEffect(() => {
    const body = document.querySelector("#root");
    body?.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  
      const container = css`
        margin-left: auto !important;
        margin-right: auto !important;
        width: 80%;
    
        @include mq("xxl", min) {
          max-width: 1427px;
        }
        @include mq("xxl") {
          max-width: 1127px;
        }
        @include mq("xl") {
          max-width: 933px;
        }
        @include mq("lg") {
          max-width: 723px;
        }
        @include mq("md") {
          max-width: 100vw;
          padding: 0 1.5rem;
        }
        `;

  return (
    <>
      <PageHero title={t.myAddresses} />
      <div className={styles.my_addresses_page}>
        <div className={container}>
          {currentPage === "ADD_ADDRESS" ? (
            <AddAddress setCurrentPage={setCurrentPage} />
          ) : (
            <div className={styles.my_addressess_holder}>
              <h2 className="heading-secondary left">{t.locationInfo}</h2>
              {userAddress?.length === 0 ? (
                <Result
                  status="404"
                  // icon={}
                  title={t.OopsAddress}
                  // title="Oops.. No result found!"
                  // subTitle="Please change dates to get a available results.."
                  extra={
                    <Button
                      type="primary"
                      size="large"
                      style={{ paddingLeft: 30, paddingRight: 30 }}
                      // className={styles.btn_add_new}
                      onClick={() => setCurrentPage("ADD_ADDRESS")}
                    >
                      <span className={styles.icon}>+</span> {t.addNewAdress}
                    </Button>
                  }
                  style={{ marginTop: "6rem" }}
                />
              ) : (
                <>
                  <Button
                    type="link"
                    className={styles.btn_add_new}
                    onClick={() => setCurrentPage("ADD_ADDRESS")}
                  >
                    <span className={styles.icon}>+</span> {t.addNewAdress}
                  </Button>
                  <ul className={styles.addresses_list}>
                    {userAddress?.map((address) => (
                      <li key={address?.Id}>
                        <div className={styles.row}>
                          <h4>{address?.Title}</h4>
                          {/* <Radio.Group
                        onChange={(e) => setaddressSelect(e.target.value)}
                        value={addressSelect}
                      >
                        <Radio
                          value={address?.Id}
                          className={styles.radio_btn}
                        />
                      </Radio.Group> */}
                        </div>
                        <div className={styles.row}>
                          <p>
                            {address?.Caption} , {address?.Street}
                          </p>
                          <Button
                            type="link"
                            onClick={() => handelDltAddress(address?.Id)}
                          >
                            <div>
                              <Image
                                src={img_1}
                                alt="img"
                                preview={false}
                                width={17}
                              />
                            </div>
                            <span>{t.removeAdress}</span>
                          </Button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </>
              )}

              {/* <Button 
                      loading={loginLoading}
                      onClick={() => onSelectAddress()}
                      type="primary" className="btn-primary fw">
                Select this adress
              </Button> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MyAddresses;
